// $(window).on('load', function() {
// $(document).on('load', function(){
// $(document).on('click', '#date', function(){
$(document).on('change', '#delivery__method', function(){

  if (window.jQuery) {
    let $ = window.jQuery;

    $(function() {
      $("#date").datepicker({
        minDate: +5, 
        maxDate: '+2M',
        // 土日指定可否
        // beforeShowDay: $.datepicker.noWeekends
      });
    });

    $.datepicker.setDefaults({
      closeText: "閉じる",
      prevText: "<先月",
      nextText: "来月>",
      currentText: "今月",
      monthNames: [ "1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月" ],
      monthNamesShort: [ "1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月" ],
      dayNames: [ "日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日" ],
      dayNamesShort: [ "日","月","火","水","木","金","土" ],
      dayNamesMin: [ "日","月","火","水","木","金","土"],
      weekHeader: "週",
      dateFormat: "yy/mm/dd",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: "年"
    });
  }
});
